<template>
  <div class="desc-item-cla">
    <template v-for="(item, index) in paramsArr">
      <div class="desc-wrapper-cla" :key="index">
        <div class="desc-header-cla">
          <div class="params-name-cla">
            {{ item.optionName }}
          </div>
          <div class="params-setting-cla">
            <template v-if="item.valueType === '1'">
              <el-switch
                v-model="item.optionValue"
                active-value="1"
                inactive-value="0"
                @change="paramsValueChange(item)"
              ></el-switch>
            </template>

            <template v-if="item.valueType === '2'">
              <el-select
                v-model="item.optionValue"
                :placeholder="$t('common.select')"
                @change="paramsValueChange(item)"
              >
                <el-option
                  v-for="p in item.optionsList"
                  :key="p.value"
                  :label="p.name"
                  :value="p.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="item.valueType === '3'">
              <el-row style="width:200px">
                <el-col :span="20"
                  ><el-slider
                    v-model="item.optionValue"
                    :min="item.minValue"
                    :max="item.maxValue"
                    style="width:160px"
                    @change="paramsValueChange(item)"
                  ></el-slider
                ></el-col>
                <el-col :span="4" align="center">
                  {{ item.optionValue }}</el-col
                >
              </el-row>
            </template>

            <template v-if="item.valueType === '4'">
              <el-row>
                <el-col :span="18">
                  <el-input
                    :disabled="item.isEdit"
                    v-model="item.optionValue"
                    :placeholder="$t('announcement.inputContent')"
                  ></el-input>
                </el-col>
                <el-col :span="6" align="center">
                  <template v-if="item.isEdit">
                    <i
                      class="el-icon-edit input-edit-cla"
                      @click.stop="editInput(item)"
                    ></i>
                  </template>
                  <template v-else>
                    <i
                      class="el-icon-check input-check-cla"
                      @click.stop="checkInput(item)"
                    ></i>
                    <i
                      class="el-icon-close input-close-cla"
                      @click.stop="closeInput(item)"
                    ></i>
                  </template>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
        <div class="desc-content-cla">
          {{ $t('device.deviceParamsDesc') }}：{{ item.describe }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputData: ''
    }
  },
  props: {
    paramsArr: {
      type: Array
    }
  },
  methods: {
    editInput(item) {
      item.isEdit = false
      this.inputData = item.optionValue
    },
    checkInput(item) {
      item.isEdit = true
      this.$emit('changes', item)
    },
    closeInput(item) {
      item.optionValue = this.inputData
      item.isEdit = true
    },
    paramsValueChange(item) {
      this.$emit('changes', item)
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.desc-item-cla {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  .desc-wrapper-cla {
    width: 400px;
    margin: 0 10px 10px 0;
    border: 1px solid @fontColor4;
    border-radius: 4px;
    line-height: 28px;
    padding: 10px;
    box-shadow: @boxShadow;
    .desc-header-cla {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      .params-name-cla {
        width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .desc-content-cla {
      overflow: hidden;
      text-overflow: ellipsis;
      color: @fontColor3;
      font-size: 12px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; // 行数
    }
  }
}
.input-edit-cla,
.input-check-cla {
  cursor: pointer;
  color: @themeColor;
}
.input-close-cla {
  cursor: pointer;
  color: @ststusFailed;
}
</style>



// WEBPACK FOOTER //
// src/components/description.vue